<template>
  <div id="app" :class="{ 'layout-preview-mobile': isLayoutPreviewMobile }">
    <router-view/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { LAYOUT_PREVIEW_MOBILE } from '@/utils/layoutPreviewMode'

  export default {
    name: 'App',
    computed: {
      ...mapGetters(['layoutPreviewMode']),
      isLayoutPreviewMobile() {
        return this.layoutPreviewMode === LAYOUT_PREVIEW_MOBILE
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue